class SidebarExpand {
  constructor() {
    this.sidebars = document.querySelectorAll('.trekkspillSidebar');
    this.soloTrekkspill = document.querySelector('#showFirst');
    this.events();
  }

  events() {
    if (this.sidebars) {
      this.sidebars.forEach(sidebar => {
        sidebar.addEventListener('click', (ev) => {

          if (ev.target.classList.contains('sidebarBox__titleRow')
             && ev.target.parentElement.parentElement.id !== "trekkspillSidebarFirst") {
            ev.target.nextElementSibling.classList.toggle('sidebarBox__description--hidden');
            ev.target.querySelector('.plus').classList.toggle('plus--open');
          } else if (ev.target.parentElement.parentElement.classList.contains('sidebarBox__titleRow')
                    && ev.target.parentElement.parentElement.parentElement.parentElement.id !== "trekkspillSidebarFirst") {
            ev.target.parentElement.parentElement.nextElementSibling.classList.toggle('sidebarBox__description--hidden');
            ev.target.parentElement.querySelector('.plus').classList.toggle('plus--open');
          }
        });
      })
    }
    if (this.soloTrekkspill) {
      this.soloTrekkspill.addEventListener('click', ev => {
        if (ev.target.classList.contains('sidebarBox__titleRow')) {
          ev.target.nextElementSibling.classList.toggle('sidebarBox__description--hidden');
        } else if (ev.target.parentElement.parentElement.classList.contains('sidebarBox__titleRow')) {
          ev.target.parentElement.parentElement.nextElementSibling.classList.toggle('sidebarBox__description--hidden');
        }
        return;
      })
    }
  }
}


export default SidebarExpand